import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProveedoresService } from '../../../../app/service/proveedores/proveedores.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ErrorDialogComponent } from '../../error-dialog/error-dialog.component';
import { SuccessDialogComponent } from '../../success-dialog/success-dialog.component';
import { SpinnerService } from '../../../../app/service/spinner-service/spinner.service';
import { lastValueFrom } from 'rxjs';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';


@Component({
  selector: 'app-nuevo-registro-proveedor-dialog',
  templateUrl: './nuevo-registro-proveedor-dialog.component.html',
  styleUrl: './nuevo-registro-proveedor-dialog.component.scss'
})
export class NuevoRegistroProveedorDialogComponent {

  proveedorForm: FormGroup
  errorValidarRfc = false
  errorValidarEspeciales = false
  errorRFCMessage = ""
  erroridCIFMessage = ""
  errorClabeBancoMessage =""
  errorTipoPersonaMessage = ""
  errorValidarCuenta = true
  errorValidarCorreo = false
  firstAccess = false
  model
  editMode = true
  headerTitle = 'Editar Proveedor'
  gallery = {
    group1: true,
    group2: false,
    group3: false,
    group4: false
  };
  mostrarError = {
    nombre: false,
    razonSocial: false,
    rfc: false,
    moneda: false,
    correo: false,
    direccion: false,
    telefono: false,
    contacto: false,
    noCuenta: false, 
    tipoCompra: false,
    tipoPersona: false,
    regimenFiscal: false,
    condicionesPago: false,
    formasPago: false,
    diasPago: false,
    banco: false,
    titular: false,
    ciudad: false,
    idCif:false,
    pais: false,
    estado: false,
    codigoPostal:false,
    empresa: false
  }
  tipoMoneda = []
  formasPago = []
  tipoCompra = []
  regimenFiscal = []
  empresas = []
  paises = []
  estados = []
  condicionesPago = []
  bancos = []
  tipoPersona = []
  loadingView = true
  step = 1
  validEmail = false
  habilitarCiudad = true

  loadingProveedor = false
  csfValid = false 
  selectedFile: File | null = null;
  pdfSrc: any = '';
  pdfName: any
  selectedFile2: File | null = null;
  pdfSrc2: any = '';
  pdfName2: any
  selectedFile3: File | null = null;
  pdfSrc3: any = '';
  pdfName3: any
  selectedFile4: File | null = null;
  pdfSrc4: any = '';
  pdfName4: any
  selectedFile5: File | null = null;
  pdfSrc5: any = '';
  pdfName5: any
  monedaSelect = []
  empresaSelect = []

  show(groupName) {
    this.gallery.group1 = (groupName == 'group1') ? true : false;
    this.gallery.group2 = (groupName == 'group2') ? true : false;
    this.gallery.group3 = (groupName == 'group3') ? true : false;
    this.gallery.group4 = (groupName == 'group4') ? true : false;
  }
  constructor( 
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) 
    public data: any, 
    private spinnerService: SpinnerService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private provedorService: ProveedoresService,
    public dialogRef: MatDialogRef<NuevoRegistroProveedorDialogComponent>) {
      this.proveedorForm = this.fb.group({
        clave: ['', [Validators.required]],
        nombre: ['', [Validators.required]],
        razonSocial: [{value:'', disabled: true}],
        tipo: ['', [Validators.required]],
        rfc: [{value: '', disabled: true}],
        moneda: ['', [Validators.required]],
        direccion: ['', [Validators.required]],
        telefono: ['', [Validators.required]],
        ciudad: ['', [Validators.required]],
        pais: ['', [Validators.required]],
        estado: ['', [Validators.required]],
        codigoPostal: ['', [Validators.required]],
        correo: ['', [Validators.required]],
        contacto: ['', [Validators.required]],
        noCuenta: ['', [Validators.required]],
        condicionesPago: ['', [Validators.required]],
        tipoCompra: ['', [Validators.required]],
        tipoPersona: ['', [Validators.required]],
        regimenFiscal: ['', [Validators.required]],
        diasPago: [1, [Validators.min(1), Validators.max(61)]],
        formasPago: ['', [Validators.required]],
        titular: ['', [Validators.required]],
        idRfc: ['', [Validators.required]],
        banco: ['', [Validators.required]],
        empresa: ['', [Validators.required]]
      })

      this.editMode = data.editMode
      this.editMode ? this.headerTitle = 'Editar Proveedor' : this.headerTitle = 'Nuevo Proveedor'
      this.getTipoMoneda()
      this.getTipoCompra()
      //this.getFormasPago()
      this.getCondicionesPago()
      this.getRegimenFiscal()
      this.getTipoPersona()
      this.getBancos()
      this.getPaises()
      this.getEmpresas()
      this.loadingView = false
  }

  ngOnInit() {
  }

  getEmpresas(){
    this.provedorService.getEmpresas(localStorage.getItem('id')).subscribe(
      data => {
        this.empresas = data
      }
    )
  }

  getTipoMoneda(){
    this.provedorService.getTiposMoneda().subscribe(
      data => {
        this.tipoMoneda = data
      }
    )
  }

  getBancos(){
    this.provedorService.getBancos().subscribe(
      data => {
        this.bancos = data
      }
    )
  }
  
  getTipoCompra(){
    this.provedorService.getTiposCompra().subscribe(
      data => {
        this.tipoCompra = data
      }
    )
  }

  getFormasPago(){
    let condicionPagoId = this.proveedorForm.get('condicionesPago')?.value;

    if(condicionPagoId === ''){
      this.formasPago = [];
    }
    this.provedorService.getFormaPago(condicionPagoId).subscribe(
      data => {
        this.formasPago = data
        console.log('data: ',this.formasPago)
      }
    )
  }

  onCondicionPagoChange(condicionPagoId: string) {
    this.getFormasPago();
  }

  getCondicionesPago(){
    this.provedorService.getCondicionesPago().subscribe(
      data => {
        this.condicionesPago = data
      }
    )
  }

  getRegimenFiscal(){
    this.provedorService.getRegimenFiscal().subscribe(
      data => {
        this.regimenFiscal = data
      }
    )
  }

  getTipoPersona(){
    this.provedorService.getTipoPersona().subscribe(
      data => {
        this.tipoPersona = data
      }
    )
  }

  validarEmail($event){
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(emailRegex.test($event)){
      this.validEmail = true
      this.errorValidarCorreo = false
    }else{
      this.validEmail = false
      this.errorValidarCorreo = true
    }
    
  }

  obtenerMulti(){
      let auxMoneda = []
      this.tipoMoneda.forEach(element => {
        let auxEl = element
        if(this.monedaSelect.includes(element.tipoMonedaId)){
          auxEl['estatus'] = true
          auxMoneda.push(auxEl)
        }else{
          auxEl['estatus'] = false
          auxMoneda.push(auxEl)
        }
      });

      return auxMoneda
  }

  obtenerMultiEmpresa(){
      let auxEmpresa = []
      this.empresas.forEach(element => {
        let auxEm = { ...element };

        if(this.empresaSelect.includes(element.empresaId)){
          auxEm.esActivo = true         
        }else{
          auxEm.esActivo = false                     
        }
        auxEm.createdBy = localStorage.getItem('id');
        auxEmpresa.push(auxEm)
      }); 

      return auxEmpresa
  }

  async validateStep(opc){
    this.resetErrors()
    await this.validarRFC()
    if(this.step === 1){

      if(this.proveedorForm.value.nombre !== '' && this.proveedorForm.value.razonSocial !== ''  && this.monedaSelect.length > 0 && this.proveedorForm.value.tipoPersona !== '' && this.proveedorForm.value.rfc !== '' && this.errorValidarRfc === false &&  this.empresaSelect.length > 0 ){
        this.nextStep(opc)
      }else{
        this.mostrarError.nombre = this.proveedorForm.value.nombre !== '' ? false : true
        this.mostrarError.razonSocial = this.proveedorForm.value.razonSocial !== '' ? false : true
        this.mostrarError.rfc = this.proveedorForm.value.rfc !== '' ? false : true
        this.mostrarError.tipoPersona = this.proveedorForm.value.tipoPersona !== '' ? false : true
        this.mostrarError.moneda = this.proveedorForm.value.moneda !== '' ? false : true
        this.mostrarError.empresa = this.proveedorForm.value.empresa !== '' ? false : true
      }
    }else if(this.step === 2){
      if(this.proveedorForm.value.correo !== '' && this.proveedorForm.value.direccion !== '' && this.proveedorForm.value.telefono !== '' && this.proveedorForm.value.contacto !== '' && this.proveedorForm.getRawValue().pais !== '' && this.proveedorForm.getRawValue().estado !== '' && this.proveedorForm.getRawValue().codigoPostal !== ''){
        this.nextStep(opc)
      }else{
        this.mostrarError.correo = this.proveedorForm.value.correo !== '' ? false : true
        this.mostrarError.direccion = this.proveedorForm.value.direccion !== '' ? false : true
        this.mostrarError.telefono = this.proveedorForm.value.telefono !== '' ? false : true
        this.mostrarError.contacto = this.proveedorForm.value.contacto !== '' ? false : true
        this.mostrarError.pais = this.proveedorForm.getRawValue().pais !== '' ? false : true
        this.mostrarError.estado = this.proveedorForm.getRawValue().estado !== '' ? false : true
        this.mostrarError.codigoPostal = this.proveedorForm.getRawValue().codigoPostal !== '' ? false : true
        this.mostrarError.ciudad = this.proveedorForm.getRawValue().ciudad !== '' ? false : true
      }
    }else
     if(this.step === 3){
      if(this.proveedorForm.value.noCuenta !== '' && this.proveedorForm.value.tipoCompra !== '' && this.proveedorForm.value.regimenFiscal !== '' && this.proveedorForm.value.condicionesPago !== '' && this.proveedorForm.value.diasPago !== '' && this.proveedorForm.value.banco !== '' && this.proveedorForm.value.formasPago !== '' && this.proveedorForm.value.titular !== '' && !this.errorValidarCuenta){
        this.nextStep(opc)
      }else{
        this.mostrarError.noCuenta = this.proveedorForm.value.noCuenta !== '' ? false : true
        this.mostrarError.banco = this.proveedorForm.value.banco !== '' ? false : true
        this.mostrarError.formasPago = this.proveedorForm.value.formasPago !== '' ? false : true
        this.mostrarError.tipoCompra = this.proveedorForm.value.tipoCompra !== '' ? false : true
        this.mostrarError.regimenFiscal = this.proveedorForm.value.regimenFiscal !== '' ? false : true
        this.mostrarError.condicionesPago = this.proveedorForm.value.condicionesPago !== '' ? false : true
        this.mostrarError.diasPago = this.proveedorForm.value.diasPago !== '' ? false : true
        this.mostrarError.titular = this.proveedorForm.value.titular !== '' ? false : true
      }
    }else{

      this.nextStep(opc)
    }
  }

  nextStep(opc){
    opc === 1 ? this.step ++ : this.step --
  }

  async getPaises(){
    this.paises = await lastValueFrom(this.provedorService.getPaises())
    // console.log(this.proveedorForm.value)
    if(!this.habilitarCiudad){
      this.getEstados()
    }
  }

  async getEstados(){
    this.estados = await lastValueFrom(this.provedorService.getEstadosPorPais(this.proveedorForm.getRawValue().pais))
  }

  async guardarProveedor(){
    this.spinnerService.setMensaje('Guardando proveedor ' + this.proveedorForm.value.nombre)
    this.spinnerService.show()
    if(!this.loadingProveedor){
      this.loadingProveedor = true
      // await this.enviarArchivo(1)

      if(this.pdfSrc2){
        await this.enviarArchivo(2)
      }

      await this.enviarArchivo(3)

      if(this.proveedorForm.value.tipoCompra === '2'){
        await this.enviarArchivo(4)
      }

      let body = {
        nombreProveedor: this.proveedorForm.value.nombre.toUpperCase(),
        razonSocial: this.proveedorForm.value.razonSocial?? '',
        tipoProveedor: this.proveedorForm.value.tipoPersona,
        regimenFiscal: this.proveedorForm.value.regimenFiscal,
        rfc: this.proveedorForm.value.rfc,
        paisId: this.proveedorForm.getRawValue().pais,
        ciudad: this.proveedorForm.getRawValue().ciudad,
        entidadId: this.proveedorForm.getRawValue().estado,
        codigoPostal: this.proveedorForm.getRawValue().codigoPostal,
        tipoCompra: this.proveedorForm.value.tipoCompra,
        direccion: this.proveedorForm.value.direccion,
        telefono: this.proveedorForm.value.telefono,
        email: this.proveedorForm.value.correo,
        contactoFacturacion: this.proveedorForm.value.contacto.toUpperCase(),
        numerodeCuenta: this.proveedorForm.value.noCuenta,
        nombreTitular: this.proveedorForm.value.titular.toUpperCase(),
        idCIF: this.proveedorForm.value.idRfc,
        condiciondePagoId: this.proveedorForm.value.condicionesPago,
        formaPagoId: this.proveedorForm.value.formasPago,
        diasdePago: this.proveedorForm.value.diasPago,
        bancosid: this.proveedorForm.value.banco,
        estatus: 1,
        createdBy: localStorage.getItem('id'),
        documentosproveedor: this.obtenerCamposPdf(),
        tiposMonedaProveedor: this.obtenerMulti(),
        proveedorEmpresa: this.obtenerMultiEmpresa()            
      }

      if(this.proveedorForm.value.tipoCompra === '2'){
        body.documentosproveedor.push({
          "claveDocumento": "REP",
          "archivo": this.proveedorForm.value.rfc+'-REP.pdf',
          "estatus": true
        })
      }

      this.provedorService.postGuardarProveedor(body).subscribe(
        data => {
          if(data.code === 400){   
            this.spinnerService.hide()       
            const dialogRef = this.dialog.open(ErrorDialogComponent, {
              width: 'auto',
              data: {
                message: data.message
              }
              
            });

            this.loadingProveedor = false
          }else if(data.code === 200){
            this.dialogRef.close({event: 1, data: data})
            this.loadingProveedor = false
            this.spinnerService.hide()
          }
        }
      )
    }
  }

  obtenerCamposPdf(){

    let array = [
      {
        "claveDocumento": "CSF",
        "archivo": this.proveedorForm.value.rfc+'-CSF.pdf',
        "estatus": true
      },
      {
        "claveDocumento": "CB",
        "archivo": this.proveedorForm.value.rfc+'-CB.pdf',
        "estatus": true
      }
    ]

    if(this.pdfSrc2){
      array.push(
      {
          "claveDocumento": "CD",
          "archivo": this.proveedorForm.value.rfc+'-CD.pdf',
          "estatus": true
      })
    }
    return array
  }

  enviarArchivo(opc)
  {
    const formData = new FormData();
    if(opc === 1){
      formData.append('fileProvider', this.selectedFile);
      formData.append('idcif', this.proveedorForm.value.idRfc);
    }else if(opc === 2){
      formData.append('fileProvider', this.selectedFile2);
    }else if(opc === 3){
      formData.append('fileProvider', this.selectedFile3);
    }else if(opc === 4){
      formData.append('fileProvider', this.selectedFile4);
    }else if(opc === 5){
      formData.append('fileProvider', this.selectedFile5);
    }
    
    if(opc === 5)
    {
      // console.log("EL 5")
      this.provedorService.solicitaCSF(formData).subscribe(
        datos => {
          if(datos.code === 400){
            const dialogRef = this.dialog.open(ErrorDialogComponent, {
              width: 'auto', 
              data: 
              {
                message: datos.message,
                isError: true
              }

            });

            this.spinnerService.hide()
            return
          }
          
          this.proveedorForm = this.fb.group({
            nombre: [datos.nombrecomercial, [Validators.required]],
            razonSocial: [datos.razonsocial, [Validators.required]],
            tipoPersona: [datos.tipopersona.toString(), [Validators.required]],
            rfc: [datos.rfc, [Validators.required]],
            idRfc: [datos.idcif, [Validators.required]],
            direccion: [datos.direccion, [Validators.required]],
            ciudad: [{value: datos.municipio, disabled: !this.habilitarCiudad}, [Validators.required]],
            pais: [{value: datos.paisId, disabled: !this.habilitarCiudad}, [Validators.required]],
            estado: [{value: datos.estadoId, disabled: !this.habilitarCiudad}, [Validators.required]],
            codigoPostal: [{value: datos.codigoPostal, disabled: !this.habilitarCiudad}, [Validators.required]],
            clave: ['', [Validators.required]],
            tipo: ['', [Validators.required]],
            moneda: ['', [Validators.required]],
            telefono: ['', [Validators.required]],
            correo: ['', [Validators.required]],
            contacto: ['', [Validators.required]],
            noCuenta: ['', [Validators.required]],
            condicionesPago: ['', [Validators.required]],
            tipoCompra: ['', [Validators.required]],
            regimenFiscal: [{value: datos.regimenesid, disabled: false}, [Validators.required]],
            diasPago: [1, [Validators.min(1), Validators.max(61)]],
            formasPago: ['', [Validators.required]],
            titular: [datos.nombrecomercial, [Validators.required]],
            banco: ['', [Validators.required]],
            empresa: ['', [Validators.required]],
          })           
          this.getPaises() 
          
          if(this.proveedorForm.get('tipoPersona').value == '1')
          {
            this.proveedorForm.get('razonSocial')?.disable()
          }
          else
          {
            this.proveedorForm.get('razonSocial')?.enable()
          }

          this.csfValid = true    
          this.firstAccess = true 
          this.validarRFC()           

        },
        error => {
          const dialogRef = this.dialog.open(ErrorDialogComponent, {
            width: 'auto',
            data: {
              message: error
            }
          });
        }
      )

      
    }
    else
    {
      this.provedorService.enviarPdf(formData).subscribe(
        data => {
          if(opc === 1)
          {
            if(data.code === 400){
              this.csfValid = false
              
              if(data.nombrecomercial!== this.proveedorForm.get('nombre').value && data.idcif !== '')
              {
                this.csfValid = false
                const dialogRef = this.dialog.open(ErrorDialogComponent, {
                  width: 'auto', 
                  data: 
                  {
                    message: data.message,
                    isError: true
                  }

                });
              }
              else{
                  const dialogRef = this.dialog.open(ErrorDialogComponent, {
                  width: 'auto',
                  data: {
                    message: data.message,
                    isError: true
                  }                
                });
              }
             
            }
            else
            {
              this.csfValid = true
            }
          }            
          /*else
          {
            this.csfValid = true
          }*/
        }
      )
    }
  }

  closeDialog(){
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: 'auto',
      disableClose: true,
      data: {
        message: '¿Deseas salir de la carga del proveedor?',
        description: 'Si confirmas, el progreso se borrará',
        confirmButton: 'Salir'
      }
    });
     dialogRef.afterClosed().subscribe(result => {
      if(!!result){
        if(result.event !== 1){
          return
        }else if(result.event === 1){
          this.dialogRef.close({event: 2})
        }
      }
    });
  }

  onFileSelected(event: any, opc): void {
    const file: File = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      this.previewPDF(file, opc, event);
    } else {
      const dialogRef = this.dialog.open(ErrorDialogComponent, {
        width: 'auto',
        data: {
          message: 'Por favor, selecciona un archivo PDF'
        }
      });
    }
  }

  previewPDF(file: File, opc, $event): void {
    const reader = new FileReader();

    reader.onload = async (e: any) => {
      const pdfData = e.target.result;
      const blob = new Blob([pdfData], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      if(opc === 1){
        const auxFile = new File([$event.target.files[0]], this.proveedorForm.value.rfc+'-CSF.pdf', {
          type: $event.target.files[0].type
        })
        this.pdfName = auxFile.name
        this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.selectedFile = auxFile;
        await this.enviarArchivo(1)
      }else if(opc === 2){
        const auxFile = new File([$event.target.files[0]], this.proveedorForm.value.rfc+'-CD.pdf', {
          type: $event.target.files[0].type
        })
        this.pdfName2 = auxFile.name
        this.pdfSrc2 = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.selectedFile2 = auxFile;
      }else if(opc === 3){
        const auxFile = new File([$event.target.files[0]], this.proveedorForm.value.rfc+'-CB.pdf', {
          type: $event.target.files[0].type
        })
        this.pdfName3 = auxFile.name
        this.pdfSrc3 = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.selectedFile3 = auxFile;
      }else if(opc === 4){
        const auxFile = new File([$event.target.files[0]], this.proveedorForm.value.rfc+'-REP.pdf', {
          type: $event.target.files[0].type
        })
        this.pdfName4 = auxFile.name
        this.pdfSrc4 = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.selectedFile4 = auxFile;
      }
      else if(opc === 5){
        this.spinnerService.setMensaje('Obteniendo datos de CSF')
        this.spinnerService.show()
        this.habilitarCiudad = false
        const auxFile = new File([$event.target.files[0]], 'CSF.pdf', {
          type: $event.target.files[0].type
        })
        this.pdfName5 = auxFile.name
        this.pdfSrc5 = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.selectedFile5 = auxFile;
        await this.enviarArchivo(5)
      }
    }; 

    reader.readAsArrayBuffer(file);
  }

  resetErrors(){
    this.mostrarError = {
      nombre: false,
      razonSocial: false,
      rfc: false,
      moneda: false,
      correo: false,
      direccion: false,
      telefono: false,
      contacto: false,
      noCuenta: false, 
      tipoCompra: false,
      tipoPersona: false,
      regimenFiscal: false,
      condicionesPago: false,
      diasPago: false,
      banco: false,
      formasPago: false,
      titular: false,
      idCif:false,
      ciudad: false,
      pais: false,
      estado: false,
      codigoPostal:false,
      empresa: false
    }
  }

  resetUploadFile(opc){
    if(opc === 1){
      this.pdfName = ''
      delete this.pdfSrc
      delete this.selectedFile
    }else if(opc === 2){
      this.pdfName2 = ''
      delete this.pdfSrc2
      delete this.selectedFile2
    }else if(opc === 3){
      this.pdfName3 = ''
      delete this.pdfSrc3
      delete this.selectedFile3
    }else if(opc === 4){
      this.pdfName4 = ''
      delete this.pdfSrc4
      delete this.selectedFile4
    }else if(opc === 5){
      this.pdfName5 = ''
      delete this.pdfSrc5
      delete this.selectedFile5
    }
    // this.file_loaded = []; 
    // this.wrongFileExtension = false
  }

  repseHabilitado(){
    return this.proveedorForm.value.tipoCompra === '2' ? true : false 
  }

  validarRFC(){
    this.spinnerService.setMensaje('Validando RFC')
    this.spinnerService.show()
    let body = {
      rfc: this.proveedorForm.value.rfc,
      tipopersona: this.proveedorForm.value.tipoPersona === '1' ? 'F' : 'M',
      operacion: 'I',
      idCIF: this.proveedorForm.value.idRfc
    }
    
    this.provedorService.validarRFC(body).subscribe(
      data => {
        if(data.code === 400)
        {
          const rfcValidaTP = this.proveedorForm.value.rfc?.trim();
          const tipo = this.proveedorForm.value.tipoPersona;

          const longitudEsperada = tipo === '1' ? 13 : tipo === '2' ? 12 : null;

          if (longitudEsperada && rfcValidaTP?.length !== longitudEsperada) 
          {
            this.errorRFCMessage = 'El RFC no corresponde con el tipo de persona seleccionado.';
          }          
          else
          {
            this.errorRFCMessage = data.message
          }

          this.errorValidarRfc = true
          
        }else{
          let sat = {
            RFC: this.proveedorForm.value.rfc,
            Tipopersona: this.proveedorForm.value.tipoPersona === '1' ? 'F' : 'M',
            idCIF: this.proveedorForm.value.idRfc
          }
          this.provedorService.validarIdRFC(sat).subscribe(
            data2 => {
              if(data2.code === 400){
                this.errorValidarRfc = true
                this.errorRFCMessage = data2.message
              }else{
                this.errorValidarRfc = false
              }
            }
          )
        }
        this.firstAccess = true
        this.spinnerService.hide()
      }
    )
  }

  validarCuenta(){
    this.spinnerService.setMensaje('Validando cuenta bancaria')
    this.spinnerService.show()

    if (this.proveedorForm.value.banco == "") 
    {
      this.errorValidarCuenta = true
      this.mostrarError.noCuenta = true
      this.errorClabeBancoMessage = 'Se requiere seleccionar un banco.';
      this.spinnerService.hide()
    }   
    else
    {

      const banco = this.bancos.find(element => element.bancosId === parseInt(this.proveedorForm.value.banco))

      let body = {
        clave: banco.clave,
        cuenta: this.proveedorForm.value.noCuenta
      }
      
      this.provedorService.getValidarBanco(body).subscribe(
        data => {
          if(data.code === 400){
            this.errorValidarCuenta = true
            this.mostrarError.noCuenta = true
            this.errorClabeBancoMessage = data.message
          }else{
            this.errorValidarCuenta = false
            this.mostrarError.noCuenta = false
          }      

          this.spinnerService.hide()
        },
        err => {
          this.errorValidarCuenta = false
          this.mostrarError.noCuenta = false
          this.spinnerService.hide()
        }
      )
    }
  }

  checkFirstAccess(){
    this.firstAccess = false
  }

  checkMinMax(){
    const inputControl = this.proveedorForm.get('diasPago');
    if (inputControl) {
      const value = inputControl?.value;
      if (value <= 0) {
        inputControl?.setValue(1);
      } else if (value > 60) {
        inputControl?.setValue(60);
      }
    }
  }

  validarCaracteres(campo){
    const valor = this.proveedorForm.get(campo)?.value || ''
    //const valorLimpio = valor.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '')
     const valorLimpio = valor.replace(/[^a-zA-Z\s]/g, '')

    if(valor !== valorLimpio){
      this.proveedorForm.get(campo).setValue(valorLimpio, {
        emitEvent: false
      })
    }
    if(this.proveedorForm.get(campo).value !== '')
      {
        this.mostrarError[campo] = false
      }
      else
      {
        this.mostrarError[campo] = true
      }
  }

  validarRfc(){
    const valor = this.proveedorForm.get('rfc')?.value || ''
    const valorLimpio = valor.replace(/[^a-zA-Z0-9\s]/g, '')
    if(valor !== valorLimpio){
      this.proveedorForm.get('rfc').setValue(valorLimpio, {
        emitEvent: false
      })
    }
  }

  validarEspeciales(campo){
    const valor = this.proveedorForm.get(campo)?.value || ''
    const valorLimpio = valor.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ0-9\s]/g, '')
    if(valor !== valorLimpio){
      this.proveedorForm.get(campo).setValue(valorLimpio, {
        emitEvent: false
      })
    }

    if(this.proveedorForm.get(campo).value !== '')
      {
        this.mostrarError[campo] = false
      }
      else
      {
        this.mostrarError[campo] = true
      }
  }

  validarNumeros(campo){
    const valor = this.proveedorForm.get(campo)?.value || ''
    const valorLimpio = valor.replace(/[^0-9\s]/g, '')
    if(valor !== valorLimpio){
      this.proveedorForm.get(campo).setValue(valorLimpio, {
        emitEvent: false
      })
    }
    if(this.proveedorForm.get(campo).value !== '')
      {
        this.mostrarError[campo] = false
      }
      else
      {
        this.mostrarError[campo] = true
      }
  }

  habilitarRFC(){
    const control = this.proveedorForm.get('rfc')

    if(this.proveedorForm.get('tipoPersona').value !== '')
    {
      this.mostrarError.tipoPersona = false
      this.mostrarError.idCif = false
      this.erroridCIFMessage =""
      this.errorTipoPersonaMessage=""
      if(this.proveedorForm.get('idRfc').value !== '')
      {
        control.enable()        
      }
      else
      {
        this.mostrarError.idCif = true
        this.erroridCIFMessage =  "Ingresa el IdCIF del proveedor"
        control.disable
      }

      if(this.proveedorForm.get('tipoPersona').value == '1')
      {
        this.proveedorForm.get('razonSocial').reset()
        this.proveedorForm.get('razonSocial')?.disable()
      }
      else
      {
        this.proveedorForm.get('razonSocial')?.enable()
      }
    }
    else
    {       
      this.mostrarError.tipoPersona = true
      this.errorTipoPersonaMessage ="Se requiere seleccionar el tipo de persona"
      control.disable
      this.proveedorForm.get('razonSocial')?.disable()
    }
  }  

  validarArchivos(){
    let repse = this.proveedorForm.value.tipoCompra === '2' ? true : false 

    if(this.pdfSrc && this.pdfSrc3){
      if(repse){
        if(this.pdfSrc4){
          return true
        }
      }else{
        return true
      }
    }
    
    return false
    
  }

  onPaisChange(event: Event){
    this.provedorService.getEstadosPorPais((event.target as HTMLSelectElement).value).subscribe(
      data => {
        this.estados = data
      }
    )
  }
  validarSeleccion() {
    if (!this.empresaSelect || this.empresaSelect.length === 0) {
      this.mostrarError.empresa = true;
    } else {
      this.mostrarError.empresa = false;
    }

    if (!this.monedaSelect || this.monedaSelect.length === 0) {
      this.mostrarError.moneda = true;
    } else {
      this.mostrarError.moneda = false;
    }
  }
} 
